import {
  AccordionDetails,
  Box,
  TableBody,
  TextField,
  makeStyles,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import arrayMove from "array-move";
import cloneDeep from "lodash/cloneDeep";
import React, { Suspense, lazy, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { Container, Draggable } from "react-smooth-dnd";
import * as Yup from "yup";
import TableCellActions from "../../../../Components/TableCellActions";
import {
  StyledAccordion,
  StyledAccordionSummary,
} from "../../../../Components/UI/Accordion";
import PrimaryButton from "../../../../Components/UI/Buttons/PrimaryButton";
import SecondaryButton from "../../../../Components/UI/Buttons/SecondaryButton";
import FormLayout from "../../../../Components/UI/FormLayout";
import {
  StyledTable,
  StyledTableCell,
  StyledTableHead,
  StyledTableRow,
} from "../../../../Components/UI/Tables/Table";
import {
  closePagesAddModal,
  closePagesEditModal,
  editPages,
  getViewData,
  toggleItemModal,
  toggleSectionModal,
} from "../../../../Stores/Pages/actions";
import { searchSlickCareProfiles } from "../../../../Stores/SlickCareProfiles/actions";
import { commonStyle } from "../../../../commonStyle";
import { GenericItemCheckBox } from "../../../../utils/SlickCareData";
import { convertToBoolean } from "../../../../utils/helpers";
import useValidator from "../../../../utils/useValidator";

const ItemModal = lazy(() => import("./ItemModal"));
const SectionModal = lazy(() => import("./SectionModal"));

const useStyles = makeStyles((theme) => ({
  sectionCard: {
    margin: `0px`,
    borderRadius: "5px",
    border: "2px solid #e5e7eb",
    marginBottom: "18px",
    position: "relative",
  },
  groupCard: {
    background: `#fff`,
    padding: "12px",
    marginBottom: "18px",
    boxShadow: `0 3px 6px hsl(0deg 0% 7% / 20%)`,
    border: "1px solid black",
  },
  itemCard: {
    border: "1px solid black",
    marginLeft: "15px",
    padding: "76px 15px 15px 15px",
    borderRadius: "4px",
    marginTop: "18px",
    position: "relative",
  },
  sectionDelBox: {
    position: "absolute",
    right: 10,
    top: 20,
  },
  input: {
    display: "none",
  },
  imageBox: {
    display: "flex",
    flexDirection: "column",
    padding: "10px 0px",
  },
  imageDelBox: {
    marginTop: 10,
  },
  descStyle: {
    padding: "32px 10px",
  },
  propertyText: {
    margin: "0",
    padding: "0",
    ...theme.typography.caption,
  },
  content: {
    maxWidth: "1280px",
    margin: "0 auto",
    padding: "0px 10px",
  },
}));

function PageModal() {
  const dispatch = useDispatch();
  const history = useHistory();
  const classes = useStyles();
  const commonClasses = commonStyle();
  const { pageID, id } = useParams();

  const { isAddModalOpen, isEditModalOpen, currentPages, isFetching } =
    useSelector((state) => state.PagesReducer);
  const { SlickCareProfiles } = useSelector(
    (state) => state.SlickCareProfilesReducer
  );

  let loading = isFetching;
  let open = isAddModalOpen || isEditModalOpen;

  const onClose = () =>
    isAddModalOpen
      ? dispatch(closePagesAddModal())
      : dispatch(closePagesEditModal());

  const [currentJSON, setCurrentJson] = useState([]);
  const [expanded, setExpanded] = React.useState(-1);

  useEffect(() => {
    dispatch(getViewData(pageID));
  }, []);

  function onSubmit() {
    const bodyFormData = new FormData();

    bodyFormData.append("page_title", values.page_title ?? "");
    bodyFormData.append("page_url", values.page_url ?? "");
    bodyFormData.append("website_id", id ?? "");

    if (currentJSON) {
      bodyFormData.append(`sections`, JSON.stringify(currentJSON));
      dispatch(
        editPages({
          data: bodyFormData,
          history,
          id: currentPages?.id,
          website_id: id,
        })
      );
    }
  }

  const { values, handleSubmit, setValues, clearFormState, touched, errors } =
    useValidator({
      initialValues: {
        page_title: "",
        page_url: "",
        sections: {},
        website_id: id,
      },
      onSubmit,
      validationSchema: Yup.object({
        page_url: Yup.string().required("Page URL is Required!"),
        page_title: Yup.string().required("Page Title is Required!"),
      }),
    });

  useEffect(() => {
    if (currentPages?.id) {
      let tempLocation = {};
      if (currentPages?.location_detail) {
        tempLocation = {
          ...currentPages.location_detail,
          id: currentPages?.location_id,
        };
      }
      setValues({
        ...values,
        id: currentPages?.id,
        page_title: currentPages?.page_title,
        page_type: currentPages.page_type,
        page_url: currentPages.page_url,
        location_id: currentPages?.location_id,
        location_detail: tempLocation,
      });
      if (
        currentPages?.sections &&
        JSON.parse(currentPages?.sections ?? []).length > 0
      ) {
        let tempSections = JSON.parse(currentPages.sections);
        tempSections.map((section) => {
          section.has_section_description = convertToBoolean(
            section.has_section_description
          );
          section.has_section_heading = convertToBoolean(
            section.has_section_heading
          );
          section.has_section_image = convertToBoolean(
            section.has_section_image
          );
          section.has_section_subheading = convertToBoolean(
            section.has_section_subheading
          );
          section.has_custom_icon = convertToBoolean(section.has_custom_icon);
          section.has_same_icon = convertToBoolean(section.has_same_icon);
          section.has_files = convertToBoolean(section.has_files);

          if (section?.items === null) {
            section.items = [];
          }
          if (section?.files === null) {
            section.files = [];
          }
          if (section?.section_cta === null) {
            section.section_cta = [];
          }
          section.location_list = section?.location_list ?? [];

          if (section?.location_list?.length > 0) {
            let obj = {};
            section.location_list.map((ele) => {
              obj[ele] = true;
            });
          }
          if (section?.items?.length > 0) {
            section.items.map((item) => {
              item.has_item_address = convertToBoolean(item.has_item_address);
              item.has_item_custom_icon = convertToBoolean(
                item.has_item_custom_icon
              );
              item.has_item_description = convertToBoolean(
                item.has_item_description
              );
              item.has_item_heading = convertToBoolean(item.has_item_heading);
              item.has_item_image = convertToBoolean(item.has_item_image);
              item.has_item_role = convertToBoolean(item.has_item_role);
              item.has_item_short_description = convertToBoolean(
                item.has_item_short_description
              );
              item.has_item_video = convertToBoolean(item.has_item_video);
              item.has_item_widget = convertToBoolean(item.has_item_widget);
              item.has_item_cta = convertToBoolean(item.has_item_cta);
            });
          }
        });
        setCurrentJson(tempSections);
      }
    }
  }, [currentPages]);

  useEffect(() => {
    dispatch(searchSlickCareProfiles({ page: 1, limit: 10, company_id: id }));
    setExpanded(-1);
  }, []);

  useEffect(() => {
    if (!open) {
      setCurrentJson([]);
      clearFormState();
    }
  }, [open]);

  const handleAddSection = (section) => {
    let tempJson = JSON.parse(JSON.stringify(currentJSON));
    tempJson.push(section);
    setCurrentJson(tempJson);
  };
  const handleEditSection = (section, sectionIndex) => {
    let tempJson = JSON.parse(JSON.stringify(currentJSON));
    tempJson.splice(sectionIndex, 1, section);
    setCurrentJson(tempJson);
  };
  const handleAddItem = (item, sectionIndex) => {
    let data = cloneDeep(currentJSON);
    data[sectionIndex].items.push(item);
    setCurrentJson(data);
  };
  const handleEditItem = (sectionIndex, itemIndex, item) => {
    let tempJson = JSON.parse(JSON.stringify(currentJSON));
    tempJson[sectionIndex].items.splice(itemIndex, 1, item);
    setCurrentJson(tempJson);
  };
  const renderPropertyText = (item) => {
    let arr = [];
    let obj = {
      totalProperties: 0,
      displayText: "",
    };
    GenericItemCheckBox.map((checkItem) => {
      if (item[checkItem.key] === true) {
        arr.push(checkItem.title);
      }
    });
    obj.totalProperties = arr.length;
    obj.displayText = arr.toString();

    return obj;
  };

  const onDrop = ({ removedIndex, addedIndex }) => {
    let data = JSON.parse(JSON.stringify(currentJSON));
    data = arrayMove(data, removedIndex, addedIndex);
    data.map((ele, i) => {
      ele.sequence = i + 1;
    });
    setCurrentJson(data);
  };

  return (
    <>
      <FormLayout
        title={`Edit Page`}
        mode={`Edit`}
        pageName="Pages"
        parentLink="/d/Pages"
        childLink="/d/Pages/add"
        customTitle={""}
      >
        <Box className={classes.content}>
          <Box className={commonClasses.titleBox}>
            <h3 className={commonClasses.title}>Page Configurations</h3>
          </Box>

          <Box className={commonClasses.flexBox}>
            <Box className={commonClasses.flexItemMD}>
              <TextField
                size="small"
                variant="outlined"
                value={values?.page_title}
                placeholder="Enter Page Title"
                label="Page Title"
                style={{ width: "100%" }}
                onChange={(e) => {
                  setValues({ ...values, page_title: e.target.value });
                }}
                helperText={touched.page_title && errors.page_title}
                error={!!(touched.page_title && errors.page_title)}
              />
            </Box>
            <Box className={commonClasses.flexItemMD}>
              <TextField
                size="small"
                variant="outlined"
                value={values?.page_url}
                placeholder="Enter Page URL"
                label="Page URL"
                style={{ width: "100%" }}
                onChange={(e) => {
                  setValues({ ...values, page_url: e.target.value });
                }}
                helperText={touched.page_url && errors.page_url}
                error={!!(touched.page_url && errors.page_url)}
              />
            </Box>
          </Box>

          <Box style={{ marginTop: "32px" }}>
            <Box className={commonClasses.titleBox}>
              <h3 className={commonClasses.title}>Page Sections</h3>
            </Box>
            {loading
              ? `Please wait`
              : currentJSON && (
                  <Box style={{ marginTop: 18 }}>
                    {currentJSON?.length > 0 ? (
                      <>
                        <Container onDrop={onDrop}>
                          {currentJSON.map((section, sectionIndex) => (
                            <Draggable key={sectionIndex}>
                              <Box
                                className={commonClasses.flexBox}
                                style={{ alignItems: "center" }}
                              >
                                <Box className={commonClasses.flexItemLG}>
                                  <StyledAccordion
                                    style={{ width: "100%" }}
                                    expanded={expanded === sectionIndex}
                                  >
                                    <StyledAccordionSummary
                                      className={
                                        commonClasses.accordionActionHeader
                                      }
                                      expandIcon={
                                        <ExpandMoreIcon
                                          onClick={() =>
                                            expanded === sectionIndex
                                              ? setExpanded(-1)
                                              : setExpanded(sectionIndex)
                                          }
                                        />
                                      }
                                    >
                                      <h3
                                        style={{ margin: 0, width: "100%" }}
                                        onClick={() =>
                                          expanded === sectionIndex
                                            ? setExpanded(-1)
                                            : setExpanded(sectionIndex)
                                        }
                                      >
                                        {section?.has_layout ? (
                                          "Layout"
                                        ) : (
                                          <>
                                            {`${
                                              section?.has_section_heading
                                                ? section?.section_heading
                                                : ""
                                            } ${section?.section_type}  ${
                                              section?.section_listing_type &&
                                              `- ${section?.section_listing_type}`
                                            }`}
                                          </>
                                        )}
                                      </h3>
                                      <TableCellActions
                                        canEdit={true}
                                        canDelete={false}
                                        editMethod={(e) => {
                                          dispatch(
                                            toggleSectionModal({
                                              open: true,
                                              mode: "edit",
                                              data: {
                                                sectionIndex,
                                                section,
                                              },
                                            })
                                          );
                                        }}
                                      />
                                    </StyledAccordionSummary>
                                    <AccordionDetails>
                                      <StyledTable>
                                        <StyledTableHead>
                                          <StyledTableRow>
                                            <StyledTableCell>
                                              Item Number
                                            </StyledTableCell>
                                            <StyledTableCell>
                                              Item Properties
                                            </StyledTableCell>
                                            <StyledTableCell>
                                              Actions
                                            </StyledTableCell>
                                          </StyledTableRow>
                                        </StyledTableHead>
                                        <TableBody>
                                          {section?.items?.length > 0 ? (
                                            section?.items?.map(
                                              (item, itemIndex) => (
                                                <StyledTableRow>
                                                  <StyledTableCell>
                                                    <p
                                                      className={
                                                        commonClasses.tableLabel
                                                      }
                                                    >
                                                      {itemIndex + 1}
                                                    </p>
                                                  </StyledTableCell>
                                                  <StyledTableCell>
                                                    {renderPropertyText(item)
                                                      .totalProperties > 0
                                                      ? renderPropertyText(item)
                                                          .displayText
                                                      : "No Properties Added"}
                                                  </StyledTableCell>
                                                  <StyledTableCell>
                                                    <TableCellActions
                                                      canEdit={true}
                                                      canDelete={false}
                                                      editMethod={() => {
                                                        dispatch(
                                                          toggleItemModal({
                                                            open: true,
                                                            mode: "edit",
                                                            data: {
                                                              sectionIndex,
                                                              itemIndex,
                                                              item,
                                                            },
                                                          })
                                                        );
                                                      }}
                                                    />
                                                  </StyledTableCell>
                                                </StyledTableRow>
                                              )
                                            )
                                          ) : (
                                            <StyledTableRow>
                                              <StyledTableCell
                                                colSpan={3}
                                                style={{
                                                  textAlign: "center",
                                                }}
                                              >
                                                <i>No Item(s) Found!</i>
                                              </StyledTableCell>
                                            </StyledTableRow>
                                          )}
                                        </TableBody>
                                      </StyledTable>
                                    </AccordionDetails>
                                  </StyledAccordion>
                                </Box>
                              </Box>
                            </Draggable>
                          ))}
                        </Container>
                      </>
                    ) : (
                      <Box>
                        <h4>No Section(s) Added.</h4>
                      </Box>
                    )}
                  </Box>
                )}
          </Box>
        </Box>
        <div className={commonClasses.pageFormFooter}>
          <form onSubmit={handleSubmit}>
            <div className={commonClasses.flexBetweeen}>
              <SecondaryButton
                onClick={() => onClose()}
                style={{ marginRight: 10 }}
              >
                Close
              </SecondaryButton>
              <PrimaryButton type="submit" hideIcon={true}>
                Save Page
              </PrimaryButton>
            </div>
          </form>
        </div>
      </FormLayout>

      <Suspense fallback={<></>}>
        <ItemModal addItem={handleAddItem} editItem={handleEditItem} />
        <SectionModal
          addSection={handleAddSection}
          editSection={handleEditSection}
        />
      </Suspense>
    </>
  );
}

export default PageModal;
